import {
	AsYouType,
	parsePhoneNumberFromString,
	isValidPhoneNumber,
} from 'libphonenumber-js';

// The country field is optional: if the user types "+", the library detects the country.
export function formattedPhoneNumber(value, country) {
	const asYouTypeFormatter = new AsYouType(country);
	return asYouTypeFormatter.input(value);
}

export function deformatPhoneNumber(formattedValue, country) {
	const phoneNumberInfo = parsePhoneNumberFromString(formattedValue, country);
	return phoneNumberInfo ? phoneNumberInfo.number : ''; // .number arrives in E.164 format
}

export function validatePhoneNumber(value, country) {
	return isValidPhoneNumber(value, country);
}
